import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['table', 'row']

  connect() {
    this.element[this.identifier] = this
    console.log('TasksTableController connected')
  }

  toggleRow(event) {
    // Stop propagation if the click was on a link or button it can handle its own action
    const target = event.target
    if (target.closest('a') || target.closest('button')) {
      event.stopPropagation()
      return
    }

    const currentRow = event.currentTarget
    const expandableRow = currentRow.nextElementSibling

    // Check if the row is expandable toggle if so, and handle icon changing
    if (expandableRow && expandableRow.classList.contains('expandable-row')) {
      const isHidden = expandableRow.classList.contains('d-none')

      if (isHidden) {
        expandableRow.classList.remove('d-none')
        const chevron = currentRow.querySelector('.expand-icon')
        if (chevron) {
          chevron.classList.remove('fa-chevron-right')
          chevron.classList.add('fa-chevron-down')
        }
      } else {
        expandableRow.classList.add('d-none')
        const chevron = currentRow.querySelector('.expand-icon')
        if (chevron) {
          chevron.classList.remove('fa-chevron-down')
          chevron.classList.add('fa-chevron-right')
        }
      }
    }
  }
}
